const zhCN = {
  getDeviceInfoFail: '获取设备信息失败！',

  listSN: '设备SN',
  listName: '设备名称',
  listOrg: '所属组织',
  listStatus: '设备状态',
  listOperation: '操作',

  listRemoveBtn: '移除',
  listAddBtn: '添加',
  
  addDeviceBtn: '添加设备',
  removeDeviceBtn: '移除设备',

  addModalTitle: '添加设备',

  addSuccess: '添加设备成功！',
  addFail: '添加设备失败！',  

  confirmBtn: '确定',
  cancelBtn: '取消',

  removeWarning: '您确定要移除该设备？',
  removeWarningDesc: '移除设备后，访客将失去该设备的使用权限！',
  removeFail: '移除失败！',

  batchRemoveWarning: 'return "您确定要移除当前选中的 " + count + " 个设备？"',
  batchRemoveSuccess: 'return "成功移除 " + count + " 个设备！"',
  bacthRemoveFail: 'return "移除失败 " + count + " 个设备！"'
}
const enUS = {
  getDeviceInfoFail: 'Get device information failed!',

  listSN: 'SN',
  listName: 'Name',
  listOrg: 'Organization',
  listStatus: 'Status',
  listOperation: 'Operation',

  listRemoveBtn: 'Remove',
  listAddBtn: 'Add',

  addDeviceBtn: 'Add Device',
  removeDeviceBtn: 'Remove Devices',

  addModalTitle: 'Add Device',

  addSuccess: 'Device added successfully!',
  addFail: 'Device added failed!',  

  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel',

  removeWarning: 'Are you sure to remove this device?',
  removeWarningDesc: 'After removing the device, the visitor will lose access to the device!',
  removeFail: 'Removal failed!',

  batchRemoveWarning: 'return "Are you sure to remove the " + count + " devices?"',
  batchRemoveSuccess: 'return "Remove " + count + " devices successfully!"',
  bacthRemoveFail: 'return "Remove " + count + " devices failed!"'
}

export default { zhCN, enUS }